/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 6/10/15.
 */
'use strict';
angular
.module('prism-ui.components.data')
.service('MetadataService', function (_, $q, MetaPropsResourceFactory, filterFilter, UtilsService) {

	var self = this;
	var serviceReady = $q.defer();
	var retrievedProperties = {};

    self.textListInputProps = {
        delimiter: '|',
        objectKey: 'stringValue'
    };

	self.propertiesPromise = serviceReady.promise;
	self.searchableProperties = [];

	var resultAsMap = function (resultData) {
		var propsMap = {};
		resultData.forEach(function (property) {
			propsMap[property.name] = property;
		});
		return propsMap;
	};

	var getMetadataPropertyList = function (deferred) {
		MetaPropsResourceFactory.query().$promise.then(function (metaProps) {
			deferred.resolve(metaProps);
			self.searchableProperties = filterFilter(metaProps, {searchable: true});
		});
		return deferred.promise;
	};

	self.initialize = function () {
		var propertiesPromise = getMetadataPropertyList($q.defer());

		propertiesPromise.then(function (initialProps) {
			retrievedProperties = resultAsMap(initialProps);
			serviceReady.resolve(true);
		});
	};

	self.cleanData = (data, componentMap) => {
		let newData = _.cloneDeep(data);
		_.forEach(componentMap, (comp, key) => {
			if (comp.uiControlHint === 'TextListInput') {
				newData.metadata.properties[key].value = UtilsService.arrayToString(comp.instanceData.value, self.textListInputProps.delimiter, self.textListInputProps.objectKey);
			}
		});
		return newData;
	};

	self.buildCustomComponentMap = function (metaProps, errorsAndWarnings, includeMVPD) {
		var components = {};
		_.forEach(metaProps, function (prop, propName) {
			var metaServiceComponent = self.getCustomMetadataProperty(propName);
			if (metaServiceComponent) {
				if (!metaServiceComponent.mvpd || includeMVPD) {
					components[propName] = metaServiceComponent;
					if (metaServiceComponent.uiControlHint === 'TextListInput') {
						prop.value = UtilsService.stringToArray(prop.value, self.textListInputProps.delimiter, self.textListInputProps.objectKey);
					}
					components[propName].instanceData = prop;
					components[propName].instanceData.errorWarning = errorsAndWarnings ? errorsAndWarnings[propName] : undefined;
				}
			}
		});

		if (includeMVPD) {
			_.forEach(components, (component) => {
				_.forEach(errorsAndWarnings, (error, index) => {
					if (component.displayName === error) {
						component.instanceData.required = component.uiControlHint !== 'CheckBox';
						_.pullAt(errorsAndWarnings, index);
					}
				});
			});
		}
		return components;
	};

	/**
	 * Gets a metadata property from system set of custom properties
	 *
	 * @param name of the metadata property
	 * @returns A metadata property with all mongodb key/values(if applicable) needed to display and save properties
	 */
	self.getCustomMetadataProperty = function (name) {
		var comp = _.cloneDeep(retrievedProperties[name]);
		if (comp) {
			return comp;
		}
		serviceReady = $q.defer();
		getMetadataPropertyList($q.defer()).then(function (newProps) {
			retrievedProperties = resultAsMap(newProps);
			comp = _.cloneDeep(retrievedProperties[name]);
			serviceReady.resolve(true);
		});

		//
        // Oops! comp will be undefined until the properties are
        // resolved.
        //
		return comp;
	};
});
